module.exports = __webpack_public_path__ + "img/Cfile.9f7927a8.png";